import { timelineList } from "@/mocks/homeData";
import type { TimelineItem } from "@/pages/home/types";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function YearTimeline() {
  return (
    <section id="year" className="w-full bg-background-100 px-4 py-20 md:px-8 md:py-28">
      <SectionHeading
        kicker="黑料网红年度汇总"
        title="一条时间线，串起全年的爆料脉络"
        desc="黑料网红年度汇总按月份排列，把每个阶段最受关注的事件收在一处，
          方便回看整年的讨论走向，也方便补上之前漏掉的部分。"
      />

      <div className="mt-12 md:mt-16">
        {timelineList.map((item: TimelineItem, index: number) => (
          <div key={item.month} className="relative flex gap-5 md:gap-8">
            <div className="flex w-16 shrink-0 flex-col items-center md:w-24">
              <span className="flex h-14 w-14 items-center justify-center rounded-full border border-background-300 bg-background-50 font-heading text-sm font-bold text-primary-600 md:h-16 md:w-16 md:text-base">
                {item.month}
              </span>
              {index !== timelineList.length - 1 ? (
                <span className="w-px flex-1 bg-background-300" />
              ) : null}
            </div>

            <div
              className={`flex-1 rounded-lg border border-background-200 bg-background-50 p-5 md:p-6 ${
                index !== timelineList.length - 1 ? "mb-5 md:mb-6" : ""
              }`}
            >
              <div className="flex flex-wrap items-center gap-3">
                <h3 className="font-heading text-base font-bold text-foreground-950 md:text-lg">
                  {item.title}
                </h3>
                <span className="inline-flex items-center rounded-full bg-accent-100 px-2.5 py-0.5 font-label text-[11px] text-accent-900">
                  {item.tag}
                </span>
              </div>
              <p className="mt-2 max-w-3xl text-[13px] leading-relaxed text-foreground-600">
                {item.summary}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}